import React, { useState, useRef, useEffect } from 'react'
import signIn from '../../../images/signup_1.gif'
import Forgot_password from '../../../images/Forgot_password.gif'
import { Form, FormGroup, Label } from 'reactstrap'
import { useForm } from "react-hook-form";
import './SignIn.css';
import ErrorComponents from '../../../components/errorComponents/ErrorComponents';
import ReactCardFlip from "react-card-flip";
import { environment } from '../../../env';
import axios from 'axios';
import { useDispatch } from "react-redux"
import { getAgeingModalAction, getRoleAction, loaderAction, loginAction, registrationSuccessModalToggle, successModalToggle, UserDataAction, UseridAction } from '../../../redux/actions/Index';
import RegisterPopup from '../../../components/Popups/RegisterPopup';
import { useMemo } from 'react';
import moment from 'moment';

const SignIn = () => {

  const { register, handleSubmit, formState: { errors }, reset, watch } = useForm();
  const [errormessage, setErrormessage] = useState("")
  const [psserr, setPsserr] = useState('')
  const [usererror, setUsererror] = useState("")
  const [registererror, setregistererror] = useState("")
  const { register: register2, formState: { errors: errors2 }, handleSubmit: handleSubmit2, watch: watch2, reset: reset2 } = useForm({ mode: "onChange" });
  const [isFlipped, setIsFlipped] = useState(false);
  const [toggalCard, setToggalCard] = useState(false);
  const [loader, setLoader] = useState(false);
  const [passwordToggle2, setPasswordToggle2] = useState(true)
  const [passwordToggle3, setPasswordToggle3] = useState(true)
  const [passwordToggle, setPasswordToggle] = useState(true)
  const [eyeIcon, setEyeIcon] = useState('fa-eye');
  const [eyeIcon2, setEyeIcon2] = useState('fa-eye');
  const [eyeIcon3, setEyeIcon3] = useState('fa-eye');
  const [projectList, setProjectList] = useState([]);
  const password = useRef({});
  password.current = watch2("password", "");
  var fpassword = watch("fpassword")
  var existingEmail = watch2("email");
  var loginpass = watch("password");
  var email = watch2("email")
  var username = watch2("username")
  const handleClick = () => {
    setIsFlipped(!isFlipped);
  };

  const passwordShow = () => {
    setPasswordToggle(!passwordToggle);
    if (eyeIcon == 'fa-eye') {
      setEyeIcon("fa-eye-slash");
    } else {
      setEyeIcon("fa-eye");
    }
  }
  const passwordShow2 = () => {
    setPasswordToggle2(!passwordToggle2);
    if (eyeIcon2 == 'fa-eye') {
      setEyeIcon2("fa-eye-slash");
    } else {
      setEyeIcon2("fa-eye");
    }
  }
  const passwordShow3 = () => {
    setPasswordToggle3(!passwordToggle3);
    if (eyeIcon3 == 'fa-eye') {
      setEyeIcon3("fa-eye-slash");
    } else {
      setEyeIcon3("fa-eye");
    }
  }
  const dispatch = useDispatch()

  const getProjectData = () => {
    try {
      axios.get(`${environment.baseUrl}project/`).then(res => {
        let data = res.data;
        setProjectList(data);

      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  const getTenantAgeing = (project) => {
    try {
      axios.get(`${environment.baseUrl}add-gala-tenant/`).then((customerdata) => {
        let array = []
        let arr = customerdata.data.filter(data => data.project.id == project)
        arr.map((data) => {
          let date1 = moment(data.aggrement_end_date);
          let date2 = moment().format('YYYY-MM-DD');
          let days = date1.diff(date2, 'days')
          if (days <= 90) {
            array.push(data)
          }
        })
        if (array.length > 0) {
          dispatch(loginAction(true))
          setLoader(false)
          dispatch(getAgeingModalAction(true));
        }
      })
      dispatch(loginAction(true))
      setLoader(false)
    }
    catch (err) {
      console.log(err);
    }
  }

  const getUserProject = (userid) => {
    try {
      axios.get(`${environment.baseUrl}user-project/${parseInt(userid)}`).then(res => {
        let data = res.data;
        getTenantAgeing(data.project)
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  const onSubmit = async (logindata) => {
    try {
      setLoader(true)
      await axios.post(`${environment.baseUrl}login/`, logindata).then(res => {
        if (res.data.code !== 400) {
          getUserProject(res.data.userid)
          dispatch(UseridAction(res.data))
          setErrormessage("");
          localStorage.setItem("userid", JSON.stringify(res.data.userid))
        }
        else {
          setLoader(false)
          setErrormessage(res?.data?.message);
        }
      })
    }
    catch (err) {
      setLoader(false)
      console.log("errs");
    }
  };

  useMemo(() => {
    if (existingEmail == "") {
      setregistererror();
    }
    if (loginpass == "") {
      setErrormessage();
    }
  }, [existingEmail, loginpass])

  const onSubmit2 = async (registerData) => {
    setLoader(true)
    registerData.is_superuser = true
    if (email != username) {
      setUsererror("Username and Email should same*")
      setLoader(false)
      return;
    } else { setUsererror(), setLoader(false) }
    try {
      await axios.post(`${environment.baseUrl}registration/`, registerData).then((response) => {
        if (response.data.code == 200) {
          dispatch(registrationSuccessModalToggle());
          reset2();
          setLoader(false)
          setTimeout(() => {
            setIsFlipped(!isFlipped);
          }, 3100)

        }
        else if (response.data.code == 400) {
          if (response.data.message.password) {
            setregistererror(response.data.message.password)
            setLoader(false)

          } else if (response.data.message.username) {
            setregistererror(response.data.message.username)
            setLoader(false)

          }
        }
      })
    }
    catch (err) {
      console.log(err);
      setLoader(false)

    }
  }

  const submitt = async (data) => {
    console.log(data);
    if (data.fpassword != data.fpassword2) {
      setPsserr("Passwords do not match");
      return
    } else {
      setPsserr('')
    }
    try {
      await axios.post(`${environment.baseUrl}forgot-password/`, data).then((response) => {
        if (response.data.code == 200) {
          dispatch(registrationSuccessModalToggle());
          reset()
          setTimeout(() => {
            setToggalCard(!toggalCard)
          }, 2000)
          setTimeout(() => {
            setregistererror('');
            setPsserr('');
          }, 5000)
        }
        else if (response.data.code == 500) {
          if (response.data.message) {
            setregistererror(response.data.message)
          } else if (response.data.message) {
            setregistererror(response.data.message)
          } else {
          }
        }
      })
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getProjectData();
  }, [])


  return (
    <>
      <RegisterPopup />
      <div className="signin-page">
        <div className="container d-flex justify-content-center align-items-center">

          <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal" flipSpeedBackToFront={0.9} flipSpeedFrontToBack={0.9}>
            {
              !toggalCard ?
                <div className="card border-0 login-card shadow-lg">
                  <div className="row m-0 p-0 w-100 h-100">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-7 px-5 pb-md-5">
                      <div className="d-flex justify-content-center flex-column py-4">
                        <label className="base-font-600 pt-5 fs-32 text-base-gray">Welcome Back...👋🏻</label>
                        <h1 className="title-font-800 pt-2  fs-48 text-base-color">SIGN IN</h1>
                      </div>
                      <div className="pt-5">
                        <Form className="d-flex flex-column gap-2" onSubmit={handleSubmit(onSubmit)}>
                          <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                            <Label htmlFor="username" className="title-font-600 fs-4 text-start text-black">
                              Username *
                            </Label>
                            <input
                              className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              id="username"
                              name="email"
                              {...register("username", { required: true })}
                              placeholder="Enter Username..."
                              type="email"
                            />
                            {errors.username && <ErrorComponents error={"Email is required *"} />}
                          </FormGroup>
                          <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                            <Label htmlFor="examplePassword" className=" title-font-600 fs-4 text-start text-black">
                              Password *
                            </Label>
                            <div className="position-relative d-flex align-items-center w-100">
                              <input type={passwordToggle3 ? "password" : "search"}
                                {...register("password", { required: true })}
                                placeholder="Enter Password..."
                                id="password"
                                name="password"
                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              />
                              <span className="eye-box" onClick={() => passwordShow3()}>
                                {
                                  eyeIcon3 !== "fa-eye" ?
                                    <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                    <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                }
                              </span>
                            </div>
                            {errors.password && <ErrorComponents error={"Password is required *"} />}
                            {errormessage && <ErrorComponents error={errormessage} />}
                          </FormGroup>
                          {
                            loader ? <button type="button" className="bg-base-color text-white rounded-3  title-font-400 py-2 px-2 my-2 fs-3  base-box-shadow border-0 gap-2 d-flex align-items-center justify-content-center" ><span
                              className="spinner-border spinner-border-sm fs-3"
                              role="status"
                              aria-hidden="true"
                            ></span>
                              <span className='title-font-500 fs-3'>Sending . . .</span></button> : <input type="submit" className="bg-base-color text-white rounded-3  title-font-400 py-2 px-2 my-2 fs-3  base-box-shadow border-0"
                            />
                          }

                        </Form>
                        <div className="d-flex justify-content-end align-items-center py-3">
                          <button className="border-0 bg-transparent title-font-500 fs-5 text-decoration-none text-black" onClick={() => setToggalCardP(!toggalCard)}>Forgot Password?</button>
                          {/* <button className="border-0 bg-transparent title-font-600 fs-5 text-decoration-underline text-base-color" onClick={handleClick}>Register here</button> */}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-lg-6 col-xl-5 p-0 bg-base-color display-center card-border-right-radius d-none d-md-block d-lg-block d-xl-block">
                      <div className=" img-card">
                        <img src={signIn} alt="" className="img-fit" />
                      </div>
                    </div>
                  </div>
                </div> :
                <div className="card border-0 login-card shadow-lg">
                  <div className="row m-0 p-0 w-100 h-100">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-7 px-5 pb-md-5">
                      <div className="d-flex justify-content-center flex-column py-4">

                        <h1 className="title-font-600 pt-5  fs-48 text-base-color">Oop's ! Forgot Password</h1>
                        <label className="base-font-500 pt-2 fs-32 text-base-gray text-capitalize">No Warries ! Please Enter <span className="base-font-500 pt-2 fs-32 text-base-color text-capitalize">Strong</span> Password.</label>
                      </div>
                      <div className="pt-5">
                        <Form className="d-flex flex-column gap-2" onSubmit={handleSubmit(submitt)}>
                          <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                            <Label htmlFor="fusername" className="title-font-600 fs-4 text-start text-black">
                              Username *
                            </Label>
                            <input
                              className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              id="fusername"
                              name="email"
                              {...register("fusername", { required: true })}
                              placeholder="Enter Usernames..."
                              type="email"
                            />
                            {errors.fusername && <ErrorComponents error={"Email is required *"} />}
                          </FormGroup>
                          <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                            <Label htmlFor="examplePassword" className=" title-font-600 fs-4 text-start text-black">
                              New Password *
                            </Label>
                            <div className="position-relative d-flex align-items-center w-100">
                              <input type={passwordToggle3 ? "password" : "search"}
                                {...register("fpassword", { required: true })}
                                placeholder="Enter New Password..."
                                id="fpassword"
                                name="fpassword"
                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              />
                              <span className="eye-box" onClick={() => passwordShow3()}>
                                {
                                  eyeIcon3 !== "fa-eye" ?
                                    <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                    <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                }
                              </span>
                            </div>
                            {errors.fpassword && <ErrorComponents error={"Password is required *"} />}
                            {errormessage && <ErrorComponents error={errormessage} />}
                          </FormGroup>
                          <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                            <Label htmlFor="ConfirmPassword" className=" title-font-500 fs-4 text-start text-black">
                              Confirm Password *
                            </Label>
                            <div className="position-relative d-flex align-items-center w-100">
                              <input
                                type={passwordToggle2 ? "password" : "search"} id='fpassword2'
                                {...register("fpassword2", {
                                  required: true,
                                })}
                                placeholder="Re-type Password"
                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              />
                              <span className="eye-box" onClick={() => passwordShow2()}>
                                {
                                  eyeIcon2 !== "fa-eye" ?
                                    <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                    <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                }
                              </span>
                            </div>
                            {errors.fpassword2 && <ErrorComponents error={errors.fpassword2?.message} />}
                          </FormGroup>
                          <input type="submit" className="bg-base-color text-white rounded-3  title-font-400 py-2 px-2 my-2 fs-3  base-box-shadow border-0"
                          />
                          {registererror && <ErrorComponents error={registererror} />}
                          {psserr && <ErrorComponents error={psserr} />}
                        </Form>
                        <div className="d-flex justify-content-end align-items-center py-3">
                          <i className='bx bx-arrow-back bx-fade-left fs-3 ps-2 fw-normal' ></i>
                          {loader ?
                            <button type="button" className="border-0 bg-transparent title-font-600 fs-4 text-decoration-underline text-base-color" ><span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                              Sending . . .</button> : <button className="border-0 bg-transparent title-font-600 fs-4 text-decoration-underline text-base-color" onClick={() => setToggalCard(!toggalCard)}>
                              Sign In</button>
                          }

                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-lg-6 col-xl-5 p-0 bg-base-color display-center card-border-right-radius ">
                      <div className=" img-card p-4 d-none d-md-block d-lg-block d-xl-block">
                        <img src={Forgot_password} alt="" className="img-fit" />
                      </div>
                    </div>
                  </div>
                </div>
            }
            <div className="card border-0 login-card shadow-lg">
              <div className="row m-0 p-0 w-100 h-100">
                <div className="col col-md-5 col-lg-5 col-xl-5 pb-md-5 bg-base-color display-center card-border-left-radius ">
                  <div className="img-card d-none d-md-block d-lg-block d-xl-block">
                    <img src={signIn} alt="" className="img-fit" />
                  </div>
                </div>
                <div className="col-12 col-md-7 col-lg-7 col-xl-7 px-5 pb-md-5">
                  <div className="d-flex justify-content-center pb-4 pt-3">
                    <h1 className="title-font-600 py-2 fs-48 text-base-color">SIGN UP</h1>
                  </div>
                  <div className="">
                    <Form className="" onSubmit={handleSubmit2(onSubmit2)}>
                      <div className="">
                        <div className="row">
                          <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                            <Label htmlFor="first_name" className="title-font-500 fs-4 text-start text-black">
                              Firstname *
                            </Label>
                            <input
                              className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              id="first_name"

                              {...register2("first_name", {
                                required: "Firstname is required *",
                                pattern: {
                                  value: /^[a-zA-Z]+$/,
                                  message: "Enter characters only"
                                }
                              })}
                              name="first_name"
                              placeholder="FirstName..."
                              type="text"
                              autoComplete="off"
                            />
                            {errors2.first_name && <ErrorComponents error={errors2.first_name?.message} />}
                          </FormGroup>
                          <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                            <Label htmlFor="last_name" className="title-font-500 fs-4 text-start text-black">
                              Lastname *
                            </Label>
                            <input
                              className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                              id="last_name"
                              {...register2("last_name", {
                                required: "Lastname is required *", pattern: {
                                  value: /^[a-zA-Z]+$/,
                                  message: "Enter characters only"
                                }
                              })}
                              name="last_name"
                              placeholder="LastName..."
                              type="text"
                            />
                            {errors2.last_name && <ErrorComponents error={errors2.last_name?.message} />}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="row">
                        <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                          <Label htmlFor="Username" className="title-font-500 fs-4 text-start text-black">
                            Username *
                          </Label>
                          <input
                            className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                            id="username"
                            {...register2("username", { required: "Username is required *" })}
                            name="username"
                            placeholder="Enter Username..."
                            type="email"
                          />
                          {errors2.username && <ErrorComponents error={errors2.username?.message} />}
                        </FormGroup>
                        <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                          <Label htmlFor=" EmailAddress" className="title-font-500 fs-4 text-start text-black">
                            Email Address *
                          </Label>
                          <input
                            className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                            id="email"
                            {...register2("email", {
                              required: "Email is required *", pattern: {
                                value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                message: "Enter valid email"
                              }
                            })}
                            name="email"
                            placeholder="Enter Email Address..."
                            type="email"
                          />
                          {errors2.email && <ErrorComponents error={errors2.email?.message} />}
                        </FormGroup>
                      </div>
                      <div className="row">
                        <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start ">
                          <Label htmlFor="password" className="title-font-500 fs-4 text-start text-black">
                            Password *
                          </Label>
                          <div className="position-relative d-flex align-items-center">
                            <input type={passwordToggle ? "password" : "search"}
                              className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100 "
                              id='password' placeholder="Password"
                              {...register2("password", {
                                required: "Password is required *",
                                minLength: {
                                  value: 8,
                                  message: "Password at least 8 characters"
                                }
                              })}

                            />
                            <span className="eye-box" onClick={() => passwordShow()}>
                              {
                                eyeIcon !== "fa-eye" ?
                                  <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                  <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                              }
                            </span>
                          </div>
                          {errors2.password && <ErrorComponents error={errors2.password?.message} />}
                        </FormGroup>
                        <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                          <Label htmlFor="ConfirmPassword" className=" title-font-500 fs-4 text-start text-black">
                            Confirm Password *
                          </Label>
                          <div className="position-relative d-flex align-items-center">
                            <input type={passwordToggle2 ? "password" : "search"} id='password2'
                              {...register2("password2", {
                                required: 'The password do not match',
                                validate: value => value === password.current || "The password do not match"
                              })}
                              placeholder="Re-type Password"
                              className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                            />
                            <span className="eye-box" onClick={() => passwordShow2()}>
                              {
                                eyeIcon2 !== "fa-eye" ?
                                  <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                  <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                              }
                            </span>
                          </div>
                          {errors2.password2 && <ErrorComponents error={errors2.password2?.message} />}
                        </FormGroup>
                      </div>
                      <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                        <Label htmlFor="Role" className=" title-font-500 fs-4 text-start text-black">
                          Role *
                        </Label>
                        <select id="is_superuser" name="role_type" className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100 ps-3"
                          {...register2("role", { required: "Role is required *" })}>
                          <option value="user">Staff</option>
                          <option value="admin">Admin</option>
                          <option value="superadmin">SuperAdmin</option>
                        </select>
                        {errors2.role_type && <ErrorComponents error={"Role is required *"} />}
                      </FormGroup>
                      <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                        <Label htmlFor="Role" className=" title-font-500 fs-4 text-start text-black">
                          Default Project *
                        </Label>
                        <select id="is_superuser" name="role_type" className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100 ps-3"
                          {...register2("project", { required: "Project is required *" })}>
                          <option value="">Select Project</option>
                          {projectList?.map((data, i) => {
                            return <option value={data.id} key={i}>{data.name}</option>;
                          })}
                        </select>
                        {errors2.project && <ErrorComponents error={errors2.project?.message} />}
                      </FormGroup>
                      <input type="submit" className="bg-base-color text-white rounded-3 col-12  title-font-400 py-2 px-2 my-2 fs-3  base-box-shadow border-0" value="Sign Up" />
                      {registererror && <ErrorComponents error={registererror} />}
                    </Form>
                    <div className="d-flex justify-content-center align-items-center py-3">
                      <span className="title-font-500 fs-4 text-decoration-none text-black">Already have an Account?</span>
                      <button className="border-0 bg-transparent title-font-500 fs-4  ps-2 text-base-color text-decoration-underline" onClick={handleClick}> Sign In</button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </ReactCardFlip>

        </div>
      </div>
    </>
  )
}

export default SignIn